var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callGraphQL } from '../../common/common';
import { createResource as createResourceMutation } from '../../../graphql/mutations';
import { isValidUpload, getBackendResource } from './ResourceQueries';
import { store, deleteResourceById } from './ResourceStorage';
/**
 * Creates a resource association in the DB
 * @param resourceName
 * @param userId
 * @param description
 * @param resourcePath
 */
function createResourceData(resourceName, userId, description, resourcePath) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {
            owner: userId,
            description,
            resourcePath,
            resourceName
        };
        return callGraphQL(createResourceMutation, { input: params }).then((resp) => {
            var _a;
            return (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.createResource;
        });
    });
}
/**
 * Uploads a resource to the Zauvu backend
 * @param resourceName
 * @param file
 * @param userId
 * @param description
 */
export function uploadResource(resourceName, file, userId, description) {
    return __awaiter(this, void 0, void 0, function* () {
        if (yield isValidUpload(resourceName)) {
            const key = yield store(file);
            return createResourceData(resourceName, userId, description, key);
        }
    });
}
/**
 * Deletes the resource from the backend by the name
 * @param resourceName
 */
export function deleteResourceByName(resourceName) {
    return __awaiter(this, void 0, void 0, function* () {
        const resource = yield getBackendResource(resourceName);
        yield deleteResourceById(resource.id, resource.resourcePath);
    });
}
